import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import TournamentTableRow, { Tournament } from './TournamentTableRow';

export interface TournamentTableProps {
  tournaments: Tournament[];
  onToggle: (id: string) => void;
  onEdit: (id: string) => void;
  onView: (id: string) => void;
  onPayments?: (id: string) => void;
  onReportsInscriptions?: (id: string) => void;
  onReportsFinancial?: (id: string) => void;
  onDelete?: (id: string) => void;
  onDuplicate?: (id: string) => void;
}

const TournamentTable: React.FC<TournamentTableProps> = ({
  tournaments,
  onToggle,
  onEdit,
  onView,
  onPayments,
  onReportsInscriptions,
  onReportsFinancial,
  onDelete,
  onDuplicate,
}) => {
  return (
    <TableContainer component={Paper} className='overflow-visible'>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#6c757d' }}>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Torneio</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Data de Início</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              <Tooltip title="Total / Ativas (não encerradas)" placement="top">
                <span>Categorias</span>
              </Tooltip>
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              <Tooltip title="Total / Não pagas" placement="top">
                <span>Inscrições</span>
              </Tooltip>
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>
              <Tooltip title="Total / Sem resultado" placement="top">
                <span>Partidas</span>
              </Tooltip>
            </TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tournaments.map((t) => (
            <TournamentTableRow
              key={t.id}
              tournament={t}
              onToggle={onToggle}
              onEdit={onEdit}
              onView={onView}
              onPayments={onPayments}
              onReportsInscriptions={onReportsInscriptions}
              onReportsFinancial={onReportsFinancial}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TournamentTable;
